import auth from './auth'
import layout from './layout'
import error from './error'
import employee from './employee'
import empty from './empty'
import button from './button'
import modal from './modal'
import form from './form'

export default {
  auth,
  layout,
  error,
  employee,
  empty,
  button,
  modal,
  form,
}
